import React from "react";

import location_png from "../assets/location.svg";
import upcoming_calendar from "../assets/upcoming_calendar.svg";
import profile_img from "../assets/avatar_placeholder.png";
import { classNames } from "../helpers";
import { TwRadialProgress } from "./tailwind";
import { profileDefaultAvatar } from "../utils/constants";

export default function SessionTile({
  dataFor = "class",
  imgSrc,
  title,
  time,
  venue,
  totalSeats,
  seatsBooked,
  seatsBookedPerc,
  bookedPeople,
  selectedForSessionDisplay,
  onClick = () => { },
}) {
  return (
    <div
      className={classNames(`grow sm:min-w-max px-4 py-4 flex flex-row items-top gap-4 cursor-pointer`,
        selectedForSessionDisplay ? "bg-primary" : "bg-white hover:bg-[#ddddddc7]",
        `border border-bright-gray rounded-2xl`)}
      onClick={onClick}
    >
      <div className="shrink-0 rounded-lg">
        <img className="w-24 sm:w-24 h-20 aspect-3/2 rounded-lg shadow-sm" src={imgSrc} alt="" />
      </div>
      <div className={`min-w-0 [min-w-full] flex-auto sm:flex-none flex flex-col gap-1`}>
        <p className={classNames("truncate text-sm font-bold", selectedForSessionDisplay ? "text-white" : "")}>{title}</p>
        <div className={"flex flex-row items-center gap-2"}>
          <img className={"w-3 h-3"} src={upcoming_calendar} alt={""} />
          <p title={time} className={`${selectedForSessionDisplay ? "text-white" : "text-granite-gray"} text-xs truncate`}>
            {time}
          </p>
        </div>
        <div className={"flex flex-row items-center gap-2"}>
          <img className={"w-3 h-3"} src={location_png} alt={""} />
          <p title={venue} className={`${selectedForSessionDisplay ? "text-white" : "text-granite-gray"} text-xs line-clamp-1 max-w-60`}>
            {venue}
          </p>
        </div>
        <div className={"flex flex-row flex-wrap items-center"}>
          {Array.isArray(bookedPeople) && bookedPeople.length > 3 ? (
            <div
              className={`flex flex-row items-center mt-4 sm:mt-0 xl:mt-2 -space-x-2 overflow-hidden`}
            >
              {bookedPeople.slice(0, 3).map((person, i) => (
                <div className='avatar' key={i}>
                  <div className='flex-none'>
                    <img src={person?.profilePic ?? profileDefaultAvatar} alt={person?.consumerFullname ?? person?.fullName ?? ""} title={person?.consumerFullname ?? person?.fullName ?? ""} className='rounded-full size-5 sm:size-6' />
                  </div>
                </div>
              ))}
              <div className='avatar placeholder'>
                <div
                  className={`${selectedForSessionDisplay
                    ? "text-secondary bg-white"
                    : "text-white bg-light-secondary"
                    } flex justify-center items-center rounded-full font-semibold text-xs size-5`}
                >
                  <span>
                    +{bookedPeople.slice(bookedPeople.length - 2).length}
                  </span>
                </div>
              </div>
            </div>
          ) : bookedPeople.length < 4 ? (
            <div
              className={`flex flex-row items-center mt-4 sm:mt-0 xl:mt-2 -space-x-2 overflow-hidden`}
            >
              {bookedPeople.map((person, i) => (
                <div className='avatar' key={i}>
                  <div className='flex-none'>
                    <img src={person.profilePic ?? profileDefaultAvatar} alt={person.fullName} title={person.fullName} className='rounded-full size-5 sm:size-6' />
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <div></div>
          )}
        </div>
      </div>
      <div className={"flex flex-col items-center ml-auto"}>
        <TwRadialProgress progress={seatsBookedPerc} className="size-9" textClassName="!text-[9px]" />
        <h3
          className={
            "text-light-secondary font-bold text-sm sm:text-base"
          }
        >
          {seatsBooked}/{totalSeats}
        </h3>
        <p className={"text-granite-gray text-xs text-center"}>
          {dataFor == "class" ? "Seats" : "Tickets"} Booked
        </p>
      </div>
    </div>
  );
}
